import React from "react";
import NavigationTabs from "./navigation-tabs";
import { useSelector } from "react-redux";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { IconButton } from "@mui/material";
import { useDispatch } from "react-redux";
import { setIsDrawerOpen } from "../../redux/actions/shared-actions";

/**
 * Displays the navigation bar.
 * @component
 * @category Components
 * @subcategory Navigation
 */

const Navigation = () => {
  const dispatch = useDispatch();
  const { loading, isDrawerOpen } = useSelector((state) => ({
    loading: state.shared.loading,
    isDrawerOpen: state.shared.isDrawerOpen,
  }));
  return (
    <>
      {!loading ? (
        <div className='navigation'>
          <img style={{ marginLeft: "10px" }} src='/cgm-logo.svg' alt='' height={40} width={80} />
          <NavigationTabs />
          <div className='navigation-drawer-toggler'>
            <IconButton
              onClick={() => {
                dispatch(setIsDrawerOpen(!isDrawerOpen));
              }}>
              <MenuOpenIcon style={isDrawerOpen ? { WebkitTransform: "scale(-1)", transform: "scaleX(-1)" } : {}} />
            </IconButton>
          </div>
        </div>
      ) : null}
    </>
  );
};
export default React.memo(Navigation);
